const SHOWCASE_IT = {
  title: 'Showcase',
  subtitle:
    'In questa pagina trovi la comparazione dei candidati in base ai requisiti più importanti',
  mobileView:
    'Abbiamo ottimizzato questa esperienza su <1>Desktop</1>, per rendere più fruibile i dati e le valutazioni sui candidati',
  lastViewUpdate:
    'Vista salvata il {{ date, datetime(format: dd/MM/yyyy) }} ore {{ date, datetime(format: HH:mm) }}',
  yes: 'Sì',
  no: 'No',
  bubbleText:
    'Questa pagina mette a confronto le caratteristiche dei profili che ti sono stati presentati. Uno strumento per aiutarti a scegliere le persone giuste.',
  emptyCandidateList:
    'Da qui potrai <strong>confrontare</strong> le caratteristiche principali dei <strong>candidati</strong> che ti abbiamo presentato.',
  tableRows: {
    photo: 'Foto',
    age: 'Età',
    seniority: 'Seniority',
    location: 'Domicilio',
    must_have: 'Must have',
    nice_to_have: 'Nice to have',
    current_global_compensation: 'Pacchetto retributivo attuale',
    desired_global_compensation: 'Pacchetto retributivo desiderato',
    non_compete_agreement: 'Patti di non concorrenza',
    notice_period: 'Preavviso',
    company: 'Azienda',
    other_selections: 'Altri<1></1>processi<1></1>di selezione',
    motivation: 'Motivazione',
    summary: 'Riassunto',
  },
  filters: {
    restoreView: 'Ripristina vista',
    interestedBut: 'Visualizza <1>Interested but</1>',
    out: 'Visualizza <1>Candidati out</1>',
  },
  benefitsCategories: {
    car: 'Auto aziendale',
    food: 'Buoni pasto o mensa',
    training: 'Formazione',
    welfare: 'Welfare',
    insurance: 'Assicurazione',
    devices: 'Dispositivi',
    remote_working: 'Smart working o flessibilità',
  },
  company: {
    freelance: 'Freelance / P.IVA',
  },
  concernsCategories: {
    brand: 'Brand',
    role: 'Ruolo',
    compensation: 'Stipendio',
    location: 'Location',
  },
  location: {
    locationAndDistance: '<strong>{{ location }}</strong>',
    locationAndDistance_withDistance:
      '<strong>{{ location }}</strong> ({{ distance }}km)',
  },
  summary: {
    readmore: 'Leggi tutto',
    hide: 'Nascondi',
  },
  chip: {
    interestedBut: 'Interested but',
    out: 'Out',
  },
  motivationToChangeValues: {
    low: 'Low',
    high: 'High',
    medium: 'Medium',
  },
  drivingTime: {
    hours: '<b>{{ hours }}</b> h',
    minutes: '<b>{{ minutes }}</b> min',
  },
  otherSelections: {
    inProgress: '{{ count }} in corso',
    notSpecified: 'Altri in corso, non specificati',
  },
  currentGlobalCompensation: {
    payTransparencyDisclaimer:
      'Richiedere informazioni sulla retribuzione attuale o passata è soggetto a limitazioni legali a partire dal 7 luglio 2026 (Direttiva (UE) 2023/970).<br/><br/>Concentrati invece sulle aspettative retributive.',
  },
};

export default SHOWCASE_IT;
